import { supabase } from "@/integrations/supabase/client";

export type LeadReportState = { lead_id: string; reported_at: string | null; has_any_report: boolean };

/**
 * A programme counts as reported when it has an overall wrap-up report, or when
 * every tour/activity on its itinerary has its own report.
 */
export async function fetchLeadReportStates(leadIds: string[]): Promise<LeadReportState[]> {
  if (!leadIds.length) return [];
  const { data, error } = await supabase.rpc("get_lead_report_states", { _lead_ids: leadIds });
  if (error) throw error;
  return (data || []) as LeadReportState[];
}
